.addToBagButton {
  padding-left: 8px;
  padding-right: 8px;
  text-wrap: nowrap;
}

.count {
  background-color: var(--colors-text-inverse);
  color: var(--colors-primary-main);
  display: inline-block;
  border-radius: 12px;
}

.iconCount {
  background-color: var(--colors-text-inverse);
  color: var(--colors-primary-main);
  border-radius: 12px;
  border: 1px solid var(--colors-grays-light);
  font-size: 12px;
  font-weight: 600;
}

.iconCtaWrapper_small,
.iconCtaWrapper_medium,
.iconCtaWrapper_large {
  --btn-icon-default-height: 40px;
  --btn-icon-default-padding-x: 8px;
}

@media (--reefer-media-tablet-min) {
  .iconCtaWrapper_medium,
  .iconCtaWrapper_large {
    --btn-icon-default-height: 48px;
  }
}
